export const UnKnown = '__autocomplete_unknown__';
export const Reset = '__autocomplete_reset__';
export const ClearSelection = '__autocomplete__clear_selection__';

export const InputChange = '__autocomplete_input_change';
export const InputBlur = '__autocomplete_input_blur';
// export const InputKeyDown = '__autocomplete_input_keydown'

export const MouseUp = '__autocomplete_mouseup__';

export const ItemMouseEnter = '__autocomplete_item_mouseenter__';
export const ItemClick = '__autocomplete_click_item__';
export const ItemMouseMove = '__autocomplete_item_mouse_move';

export const keyDownArrowUp = '__autocomplete_keydown_arrow_up__';
export const keyDownArrowDown = '__autocomplete_keydown_arrow_down__';
export const keyDownEscape = '__autocomplete_keydown_escape__';
export const keyDownEnter = '__autocomplete_keydown_enter__';
export const keyDownHome = '__autocomplete_keydown_home__';
export const keyDownEnd = '__autocomplete_keydown_end__';

export const KeyDownArrowUp = '__autocomplete_keydown_arrow_up__';
export const KeyDownArrowDown = '__autocomplete_keydown_arrow_down__';
export const KeyDownEscape = '__autocomplete_keydown_escape__';
export const KeyDownEnter = '__autocomplete_keydown_enter__';
export const KeyDownHome = '__autocomplete_keydown_home__';
export const KeyDownEnd = '__autocomplete_keydown_end__';
export const keyDownSpaceButton = '__autocomplete_keydown_space_button__';

export const MenuOpen = '__autocomplete_menu_open__';
export const MenuClose = '__autocomplete_menu_close__';
export const MenuToggle = '__autocomplete_menu_toggle__';

export const MenuItemSelect = '__autocomplete_menu_item_select__';
export const MenuItemSelectAtIndex = '__autocomplete_menu_item_select_at_index__';
export const MenuItemSelectAtHighlightedIndex =
  '__autocomplete_menu_item_select_at_highlighted_index';

export const SetHightlightedIndex = '__autocomplete_set_highlighted_index__';

// export const clickButton = '__autocomplete_click_button__'
// export const blurButton = '__autocomplete_blur_button__'
export const controlledPropUpdatedSelectedItem =
  '__autocomplete_controlled_prop_updated_selected_item__';

export const OutsideAutosuggestClick = '__autocomplete_outside_click';

export const touchEnd = '__autocomplete_touchend__';

export const onInitialValueChange =  '__autocomplete_input';